function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

class StoresMap extends HTMLElement {
  static MAP_STYLES = [
    {
      stylers: [
        {
          color: '#d0cac9',
        },
      ],
    },
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#d0cac9',
        },
      ],
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      elementType: 'labels.text',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#757575',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text',
      stylers: [
        {
          lightness: 100,
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#bdbdbd',
        },
      ],
    },
    {
      featureType: 'poi',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#181818',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#1b1b1b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#bfb7b9',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#8a8a8a',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#bfb7b9',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#b5b5b5',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#bfb7b9',
        },
      ],
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'geometry',
      stylers: [
        {
          color: '#bfb7b9',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [
        {
          color: '#bfb7b9',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#bababa',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#e8e8e8',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          weight: 4.5,
        },
      ],
    },
  ]

  /**
   * @type {<{id: string, coords: {lat: number, lng: number}, Marker: google.maps.Marker}>[]}
   */
  markers = []

  constructor() {
    super()

    this.container = this.querySelector('.stores-map__map__inner')
    this.map = null
    this.latestInfoWindowOpened = null

    this.addMarker = this.addMarker.bind(this)
  }

  get props() {
    return {
      apiKey: this.getAttribute('data-api-key'),
      markerIcon: this.getAttribute('data-marker-icon'),
      markerCollaboratorIcon: this.getAttribute('data-marker-collaborator-icon'),
      mapLatitude: Number(this.getAttribute('data-map-latitude')),
      mapLongitude: Number(this.getAttribute('data-map-longitude')),
      mapZoom: Number(this.getAttribute('data-map-zoom')),
      howToReachText: this.getAttribute('data-how-to-reach-text'),
    }
  }

  connectedCallback() {
    this.loadGoogleMapsScript().then(() => {
      this.initMap(this)
      this.renderInitialMarkers()

      const autocompleteInput = document.querySelector('#stores-map-autocomplete')
      if (autocompleteInput) {
        this.initAutocomplete(autocompleteInput)
      }

      const geolocationButton = document.querySelector('#stores-map-geolocation')
      if (geolocationButton) {
        this.initGeolocation(geolocationButton)
      }
    })
  }

  loadGoogleMapsScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      document.body.appendChild(script)
      script.onload = resolve
      script.onerror = reject
      script.async = true
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.props.apiKey + '&libraries=places'
    })
  }

  initMap() {
    this.map = new google.maps.Map(this.container, {
      zoom: this.props.mapZoom,
      center: new google.maps.LatLng(this.props.mapLatitude, this.props.mapLongitude),
      draggable: true,
      clickableIcons: true,
      scrollwheel: true,
      disableDoubleClickZoom: true,
      disableDefaultUI: true,
      styles: StoresMap.MAP_STYLES,
    })

    google.maps.event.addDomListener(window, 'resize', () => google.maps.event.trigger(this.map, 'resize'))
  }

  /**
   * @param {HTMLInputElement} input
   */
  initAutocomplete(input) {
    const options = {
      fields: ['geometry'],
      strictBounds: false,
      types: ['(regions)'],
    }
    const autocomplete = new google.maps.places.Autocomplete(input, options)
    const clearButton = document.querySelector('#stores-map-autocomplete-clear')

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()

      if (!place.geometry || !place.geometry.viewport) {
        console.warn('No geometry returned for selected place')
        return
      }

      // Zoom map to place
      this.map.fitBounds(place.geometry.viewport)

      // Wait until map is idle
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        this.showVisibleMarkers()
      })

      // Show clear button and add events
      if (clearButton) {
        clearButton.style.display = 'inherit'
        const clearButtonClick = () => {
          clearButton.style.display = 'none'
          input.value = ''

          // Remove event after click
          clearButton.removeEventListener('click', clearButtonClick)

          // Reset map
          this.map.setCenter(new google.maps.LatLng(this.props.mapLatitude, this.props.mapLongitude))
          this.map.setZoom(this.props.mapZoom)
          this.showAllMarkers()
        }

        // Set event
        clearButton.addEventListener('click', clearButtonClick)
      }
    })
  }

  initGeolocation(button) {
    if (!navigator.geolocation) {
      button.display = 'none'
      return
    }

    button.addEventListener('click', () => {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }

        this.map.setCenter(userLocation)
        this.map.setZoom(14)
      })
    })
  }

  showVisibleMarkers() {
    const list = document.getElementById('stores-map-markers-list')

    if (!list) {
      throw new Error('No #stores-map-markers-list element found')
    }

    if (!list.classList.contains('stores-map-markers-list--only-visible')) {
      list.classList.add('stores-map-markers-list--only-visible')
    }

    const bounds = this.map.getBounds()
    const visibleMarkers = this.markers.filter(({ coords }) =>
      bounds.contains(new google.maps.LatLng(coords.lat, coords.lng))
    )

    if (visibleMarkers.length === 0) {
      document.getElementById('stores-map-list-empty').style.display = 'block'
      return
    }

    document.getElementById('stores-map-list-empty').style.display = 'none'

    // Hide current visible markers
    const currentVisibleMarkers = list.querySelectorAll('.stores-map-marker--visible')
    currentVisibleMarkers.forEach((marker) => {
      marker.classList.remove('stores-map-marker--visible')
    })

    // Show visible markers
    visibleMarkers.forEach((marker) => {
      const card = document.querySelector(`stores-map-marker[marker-id="${marker.id}"]`)
      card.classList.add('stores-map-marker--visible')
    })
  }

  showAllMarkers() {
    const list = document.getElementById('stores-map-markers-list')

    if (!list) {
      throw new Error('No #stores-map-markers-list element found')
    }

    if (list.classList.contains('stores-map-markers-list--only-visible')) {
      list.classList.remove('stores-map-markers-list--only-visible')
    }

    document.getElementById('stores-map-list-empty').style.display = 'none'

    // Remove visible flag
    const currentVisibleMarkers = list.querySelectorAll('.stores-map-marker--visible')
    currentVisibleMarkers.forEach((marker) => {
      marker.classList.remove('stores-map-marker--visible')
    })
  }

  renderInitialMarkers() {
    const initialMarkers = this.getAttribute('initial-markers')?.trim()

    if (!initialMarkers) {
      return
    }

    const markers = JSON.parse(initialMarkers)

    markers.forEach((marker) => {
      let popover = undefined

      if (marker.title && marker.how_to_reach_link) {
        popover = createPopoverElement(marker.title, marker.how_to_reach_link, this.props.howToReachText)
      }

      this.addMarker({
        id: uuid(),
        lat: marker.latitude,
        lng: marker.longitude,
        title: marker.title,
        popover,
      })
    })
  }

  /**
   * @param {Object} options
   * @param {String} options.id
   * @param {String | undefined} options.title
   * @param {Number} options.lat
   * @param {Number} options.lng
   * @param {Number | undefined} options.isCollaborator
   * @param {HTMLElement | undefined} options.popover
   */
  async addMarker(options) {
    await this.waitForMap()

    const icon = options.isCollaborator ? this.props.markerCollaboratorIcon : this.props.markerIcon

    let infowindow

    if (options.popover) {
      infowindow = new google.maps.InfoWindow({
        content: options.popover,
      })
    }

    const marker = new google.maps.Marker({
      map: this.map,
      position: new google.maps.LatLng(options.lat, options.lng),
      title: options.title,
      icon,
    })

    this.markers.push({
      id: options.id,
      coords: { lat: options.lat, lng: options.lng },
      Marker: marker,
    })

    if (options.popover) {
      const popover = createPopover(new google.maps.LatLng(options.lat, options.lng), options.popover)
      popover.setMap(this.map)
      this.map.addListener('click', popover.hide.bind(popover))
      this.addEventListener('stores-map:marker-clicked', popover.hide.bind(popover))
      this.addEventListener('stores-map:marker-open-popover', (event) => {
        if (event.detail.id !== options.id) {
          popover.hide()
          return
        }

        popover.show()
      })
    }

    marker.addListener('click', () => {
      this.dispatchEvent(
        new CustomEvent('stores-map:marker-clicked', {
          detail: {
            id: options.id,
          },
        })
      )

      if (options.popover) {
        this.dispatchEvent(
          new CustomEvent('stores-map:marker-open-popover', {
            detail: {
              id: options.id,
            },
          })
        )
      }
    })
  }

  centerMarker(markerId, zoom = this.props.mapZoom) {
    const marker = this.markers.find((marker) => marker.id === markerId)

    if (!marker) {
      return
    }

    this.map.setCenter(new google.maps.LatLng(marker.coords.lat, marker.coords.lng))
    this.map.setZoom(zoom)
    this.dispatchEvent(
      new CustomEvent('stores-map:marker-open-popover', {
        detail: {
          id: markerId,
        },
      })
    )
  }

  waitForMap() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (this.map) {
          clearInterval(interval)
          resolve()
        }
      }, 100)
    })
  }
}

if (!customElements.get('stores-map')) {
  customElements.define('stores-map', StoresMap)
}

class StoresMapMarker extends HTMLElement {
  constructor() {
    super()

    this.popoverContent = null
  }

  get props() {
    return {
      title: this.getAttribute('data-title'),
      lat: Number(this.getAttribute('data-lat')),
      lng: Number(this.getAttribute('data-lng')),
      isCollaborator: this.getAttribute('data-is-collaborator') === 'true',
      howToReachLink: this.getAttribute('data-how-to-reach-link'),
      howToReachText: this.getAttribute('data-how-to-reach-text'),
    }
  }

  getContentHowToReachLink() {
    const links = Array.from(this.querySelectorAll('.stores-map__location__body a'))
    const googleMapsLink = links.find(
      (link) => link.href.includes('https://www.google.com/maps') || link.href.includes('https://maps.app.goo.gl/')
    )

    return googleMapsLink.href
  }

  connectedCallback() {
    const storesMap = document.querySelector('stores-map')

    if (!storesMap) {
      throw new Error('stores-map-marker should be used adjacent to stores-map')
    }

    this.popoverContent = createPopoverElement(this.props.title, this.props.howToReachLink, this.props.howToReachText)

    // v4 uuid
    const id = uuid()

    // Scroll into view if marker is clicked
    storesMap.addEventListener('stores-map:marker-clicked', (event) => {
      if (event.detail.id !== id) {
        this.classList.remove('stores-map-marker--visible')
        return
      }

      this.parentNode.scrollTo({
        top: this.offsetTop - this.parentNode.offsetTop - 5,
        behavior: 'smooth',
      })

      this.classList.add('stores-map-marker--visible')
    })

    this.addEventListener('click', () => {
      this.parentNode.dispatchEvent(
        new CustomEvent('stores-map-marker:card-clicked', {
          detail: {
            id,
          },
        })
      )
    })

    this.parentNode.addEventListener('stores-map-marker:card-clicked', (event) => {
      if (event.detail.id !== id) {
        this.classList.remove('stores-map-marker--visible')
        return
      }

      this.classList.add('stores-map-marker--visible')
      storesMap.centerMarker(id, 16)
    })

    this.setAttribute('marker-id', id)

    if (storesMap) {
      storesMap.addMarker({
        id,
        title: this.props.title,
        lat: this.props.lat,
        lng: this.props.lng,
        isCollaborator: this.props.isCollaborator,
        popover: this.popoverContent,
      })
    }
  }
}

if (!customElements.get('stores-map-marker')) {
  customElements.define('stores-map-marker', StoresMapMarker)
}

function createPopover(position, content) {
  class Popover extends google.maps.OverlayView {
    position
    containerDiv
    constructor(position, content) {
      super()
      this.position = position
      content.classList.add('popover__bubble')

      const bubbleAnchor = document.createElement('div')

      bubbleAnchor.classList.add('popover__bubble-anchor')
      bubbleAnchor.appendChild(content)

      this.containerDiv = document.createElement('div')
      this.containerDiv.classList.add('popover__container')
      this.containerDiv.appendChild(bubbleAnchor)

      Popover.preventMapHitsAndGesturesFrom(this.containerDiv)
    }

    show() {
      this.getPanes().floatPane.appendChild(this.containerDiv)
    }

    hide() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }
    }

    onAdd() {
      // this.getPanes().floatPane.appendChild(this.containerDiv)
    }

    onRemove() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }
    }

    draw() {
      const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)
      // Hide the popup when it is far out of view.
      const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none'

      if (display === 'block') {
        this.containerDiv.style.left = divPosition.x + 'px'
        this.containerDiv.style.top = divPosition.y + 'px'
      }

      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display
      }
    }
  }

  return new Popover(position, content)
}

/**
 * @param {string} title
 * @param {string | undefined} googleMapsLink
 * @returns {HTMLElement}
 */
function createPopoverElement(title, googleMapsLink, howToReachText) {
  const $popover = document.createElement('div')

  $popover.classList.add('stores-map__popover')

  const $title = document.createElement('h3')
  $title.classList.add('stores-map__popover-title')
  $title.textContent = title
  $popover.appendChild($title)

  if (googleMapsLink) {
    const $howToReachLink = document.createElement('a')
    $howToReachLink.classList.add('stores-map__popover-link')
    $howToReachLink.textContent = howToReachText
    $howToReachLink.href = googleMapsLink
    $howToReachLink.target = '_blank'
    $popover.appendChild($howToReachLink)
  }

  return $popover
}
